import { render, staticRenderFns } from "./accpetOrders.vue?vue&type=template&id=246832f2"
import script from "./accpetOrders.vue?vue&type=script&lang=js"
export * from "./accpetOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports